import {IFileDetailsStoreState} from './IFileDetailsStoreState';

export const fileDetailsReducer = {
  clear(state: IFileDetailsStoreState) {
    state.fileDetails = null;
  },
};
